import { LocaleEnum } from '@systemeio/ui'

export const getHelpPageLinkZoom = (locale?: LocaleEnum) => {
  switch (locale) {
    case LocaleEnum.FRENCH:
      return 'https://aide.systeme.io/article/3921-comment-integrer-zoom-avec-systeme-io'
    case LocaleEnum.SPANISH:
      return 'https://help-es.systeme.io/article/3995-como-integrar-zoom-con-systeme-io'
    case LocaleEnum.JAPANESE:
      return 'https://help-jp.systeme.io/article/4241-how-to-integrate-zoom-with-systeme-io'
    default: {
      return 'https://help.systeme.io/article/3918-how-to-integrate-zoom-with-systeme-io'
    }
  }
}
